function initShoppableVideo(section) {
  var splideElement = section.querySelector('.shoppable-video-splide');
  if (!splideElement) return;

  if (typeof Splide === 'undefined') {
    setTimeout(function() {
      initShoppableVideo(section);
    }, 50);
    return;
  }

  if (splideElement._splide) {
    try {
      splideElement._splide.destroy(true);
    } catch(e) {}
  }

  var desktopPerPage = parseFloat(splideElement.getAttribute('data-desktop-per-page')) || 4;
  var mobilePerPage = parseFloat(splideElement.getAttribute('data-mobile-per-page')) || 1.5;
  
  var desktopArrows = splideElement.getAttribute('data-desktop-arrows') === 'true';
  var desktopPagination = splideElement.getAttribute('data-desktop-pagination') === 'true';
  var mobileArrows = splideElement.getAttribute('data-mobile-arrows') === 'true';
  var mobilePagination = splideElement.getAttribute('data-mobile-pagination') === 'true';
  var showPaginationDots = splideElement.getAttribute('data-show-pagination-dots') === 'true';
  var paginationPosition = splideElement.getAttribute('data-pagination-position') || 'on_video';
  
  var showSoundIcon = section.getAttribute('data-show-sound') === 'true';
  
  var autoScroll = splideElement.getAttribute('data-auto-scroll') === 'true';
  var autoScrollSpeed = parseFloat(splideElement.getAttribute('data-auto-scroll-speed')) || 3;
  var intervalMs = Math.round(autoScrollSpeed * 1000);
  
  var splide = new Splide(splideElement, {
    type: 'loop',
    perPage: desktopPerPage,
    gap: '20px',
    arrows: desktopArrows,
    pagination: desktopPagination,
    autoplay: autoScroll,
    interval: intervalMs,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: false,
    focus: 0,
    trimSpace: false,
    breakpoints: {
      768: {
        perPage: mobilePerPage,
        arrows: mobileArrows,
        pagination: showPaginationDots,
        gap: '15px'
      }
    }
  });

  splideElement._splide = splide;

  var bar = splideElement.querySelector('.splide-progress__bar');
  var progressContainer = splideElement.querySelector('.splide-progress');
  
  // Hide progress container if pagination dots are enabled on mobile, or if disabled
  function updateProgressVisibility() {
    var isMobile = window.innerWidth <= 768;
    if (isMobile) {
      if (showPaginationDots) {
        if (progressContainer) progressContainer.style.display = 'none';
      } else if (mobilePagination) {
        if (progressContainer) progressContainer.style.display = 'block';
      } else {
        if (progressContainer) progressContainer.style.display = 'none';
      }
    } else {
      if (desktopPagination) {
        if (progressContainer) progressContainer.style.display = 'block';
      } else {
        if (progressContainer) progressContainer.style.display = 'none';
      }
    }
  }
  
  function updatePaginationPosition() {
    if (window.innerWidth <= 768 && showPaginationDots) {
      var productList = splideElement.querySelector('.video-products-list');
      if (productList) {
        var h = productList.offsetHeight;
        if (h > 0) {
          splideElement.style.setProperty('--video-product-height', h + 'px');
        }
      }
    }
  }
  
  window.addEventListener('resize', updateProgressVisibility);
  window.addEventListener('resize', updatePaginationPosition);
  updateProgressVisibility();

  if (bar) {
    splide.on('mounted move', function () {
      var end  = splide.Components.Controller.getEnd() + 1;
      var rate = Math.min( ( splide.index + 1 ) / end, 1 );
      bar.style.width = String( 100 * rate ) + '%';
    });
  }

  splide.on('mounted move resize', updatePaginationPosition);
  splide.mount();
  updatePaginationPosition();

  // Video Interaction Logic
  var videoCards = section.querySelectorAll('.shoppable-video-card');
  
  videoCards.forEach(function(card) {
    var container = card.querySelector('.video-container');
    if (!container) return;

    var video = card.querySelector('video');
    var soundBtn = card.querySelector('.sound-toggle-btn');
    var iconSpeaker = card.querySelector('.icon-speaker');
    var iconMuted = card.querySelector('.icon-speaker-muted');

    if (video && showSoundIcon && soundBtn) {
      soundBtn.classList.remove('hide');
    }

    var seekAttr = card.getAttribute('data-seek-thumbnail') || (video ? video.getAttribute('data-seek-thumbnail') : null);
    var seekTime = seekAttr ? parseFloat(seekAttr) : 0;

    if (video && seekTime > 0) {
      var setPreviewFrame = function() {
        if (!card.dataset.hasPlayed && video.currentTime === 0) {
          try {
            var target = (video.duration && video.duration > 0 && video.duration < seekTime)
              ? (video.duration / 2)
              : seekTime;
            video.currentTime = target;
          } catch(err) {}
        }
      };

      if (video.readyState >= 1) {
        setPreviewFrame();
      } else {
        video.addEventListener('loadedmetadata', setPreviewFrame, { once: true });
        video.addEventListener('loadeddata', setPreviewFrame, { once: true });
      }
    }

    function playVideo(pauseAutoplay) {
      if (!video) return;
      if (seekTime > 0 && !card.dataset.hasPlayed) {
        try {
          video.currentTime = 0;
        } catch(err) {}
        card.dataset.hasPlayed = 'true';
      }
      video.play().catch(function(e) {
        console.log("Autoplay prevented: ", e);
      });
      card.classList.add('is-playing');
      if (pauseAutoplay !== false && autoScroll && splide.Components && splide.Components.Autoplay) {
        splide.Components.Autoplay.pause();
      }
    }

    function pauseVideo() {
      if (!video) return;
      video.pause();
      card.classList.remove('is-playing');
      if (autoScroll && splide.Components && splide.Components.Autoplay) {
        var anyPlaying = section.querySelector('.shoppable-video-card.is-playing');
        if (!anyPlaying) {
          splide.Components.Autoplay.play();
        }
      }
    }

    card._playVideo = playVideo;
    card._pauseVideo = pauseVideo;

    function toggleSound(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation(); // prevent triggering video click or link navigation
      }
      if (!video) return;
      video.muted = !video.muted;
      if (video.muted) {
        if (iconSpeaker) iconSpeaker.classList.add('hide');
        if (iconMuted) iconMuted.classList.remove('hide');
      } else {
        if (iconSpeaker) iconSpeaker.classList.remove('hide');
        if (iconMuted) iconMuted.classList.add('hide');
      }
    }

    // Desktop Hover
    container.addEventListener('mouseenter', function() {
      if (window.innerWidth > 768) {
        playVideo();
      }
    });
    container.addEventListener('mouseleave', function() {
      if (window.innerWidth > 768) {
        pauseVideo();
      }
    });

    // Mobile/Desktop Click to toggle or redirect to collection
    container.addEventListener('click', function(e) {
      if (e.target.closest('.sound-toggle-btn')) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      // If container is an anchor with a collection link, allow navigation
      if (container.tagName === 'A' && container.getAttribute('href')) {
        return;
      }
      
      var collectionLink = container.getAttribute('data-collection-link');
      var hasProducts = card.getAttribute('data-has-products') === 'true';

      // When no products are given for this block, clicking the video redirects to the collection link
      if (!hasProducts && collectionLink) {
        window.location.href = collectionLink;
        return;
      }

      if (!video) return;

      if (video.paused) {
        playVideo();
      } else {
        pauseVideo();
      }
    });

    // Sound button click
    if (soundBtn) {
      soundBtn.addEventListener('click', toggleSound);
    }
  });

  // Pause auto-scroll when a product size panel is toggled open
  section.addEventListener('click', function(e) {
    if (autoScroll && splide.Components && splide.Components.Autoplay) {
      if (e.target.closest('[data-product-card-size-toggle]')) {
        setTimeout(function() {
          var openPanel = section.querySelector('.product-card-revamp__size-panel:not([hidden])');
          if (openPanel) {
            splide.Components.Autoplay.pause();
          } else {
            splide.Components.Autoplay.play();
          }
        }, 50);
      } else if (e.target.closest('[data-product-card-size-close]')) {
        splide.Components.Autoplay.play();
      }
    }
  });

  // Mobile Autoplay on Slide
  splide.on('active', function(slide) {
    if (window.innerWidth <= 768) {
      var card = slide.slide.querySelector('.shoppable-video-card');
      if (card && card._playVideo) {
        card._playVideo(false);
      } else if (card) {
        var video = card.querySelector('video');
        if (video) {
          video.play().catch(function(e){});
          card.classList.add('is-playing');
        }
      }
    }
  });

  splide.on('inactive', function(slide) {
    if (window.innerWidth <= 768) {
      var card = slide.slide.querySelector('.shoppable-video-card');
      if (card && card._pauseVideo) {
        card._pauseVideo();
      } else if (card) {
        var video = card.querySelector('video');
        if (video) {
          video.pause();
          card.classList.remove('is-playing');
        }
      }
    }
  });
}

function initAllShoppableVideoSections() {
  var sectionElements = document.querySelectorAll('.shoppable-video-section');
  sectionElements.forEach(function(section) {
    initShoppableVideo(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllShoppableVideoSections);
} else {
  initAllShoppableVideoSections();
}

document.addEventListener('shopify:section:load', function (event) {
  if (event.target) {
    var sectionEl = event.target.matches('.shoppable-video-section') ? event.target : event.target.querySelector('.shoppable-video-section');
    if (sectionEl) {
      initShoppableVideo(sectionEl);
    }
  }
});
